import { useMutation } from "@tanstack/react-query";
import {
  CreateSymptom,
  DeleteSymptom,
  DragAndDropSymptom,
  UpdateSymptom,
} from "../../../Api/Symptom";

export const useMutateDeleteSymptom = () =>
  useMutation({
    mutationFn: (data) => DeleteSymptom(data),
  });

export const useMutateDragDropSymptom = () =>
  useMutation({
    mutationFn: (data) => DragAndDropSymptom(data),
  });

export const useMutateCreateSymptom = () =>
  useMutation({
    mutationFn: (data) => CreateSymptom(data),
  });

export const useMutateEditSymptom = () =>
  useMutation({
    mutationFn: (data) => UpdateSymptom(data),
  });
